import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map } from 'rxjs';
import { mapDto } from '@shared/operators';
import { Student, StudentDto, StudentCreateValue, StudentCreateValueDto, StudentUpdateValue, StudentUpdateValueDto } from '../models';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private httpClient = inject(HttpClient);

    getStudent(id: string) {
        return this.httpClient.get<StudentDto>(`manage/users/${id}`).pipe(mapDto((response) => new Student(response)));
    }

    addStudent(value: StudentCreateValue) {
        const params = new StudentCreateValueDto(value);

        return this.httpClient.post<unknown>('manage/users', params).pipe(map(() => true));
    }

    updateStudent(id: string, value: StudentUpdateValue) {
        const params = new StudentUpdateValueDto(value);

        return this.httpClient.patch<unknown>(`manage/users/${id}`, params).pipe(map(() => true));
    }

    deleteStudent(id: string) {
        return this.httpClient.delete<unknown>(`manage/users/${id}`).pipe(map(() => null));
    }
}
